<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay persistent>
    <v-card ref="pageDialog">
      <v-toolbar fixed dark class="primary">
        <v-btn icon @click.native="close" dark> <v-icon>close</v-icon> </v-btn>
        <v-toolbar-title>Modifica elemento menu</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn :disabled="!removePersEnabled" @click.native="removePers" dark> Rimuovi personalizzazioni </v-btn>
      </v-toolbar>
      <ProdEditor
        @save="save"
        :inComb="inComb"
        :listinoDaMenu="listino"
        :fromMenu="true"
        :edited="edited"
        @cloneVariants="toCloneProduct => onCloneProductVariants(toCloneProduct)"
      />
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Wrapper per ProdEditor ( lo include all'interno di un dialog fullscreen )
 * @module components/common/ProdEditorFull
 */
import ProdEditor from './ProdEditor.vue'
export default {
  /**
   * @prop editing {object} - L'oggetto modificato
   * @prop listino {string} - Il listino di riferimento
   * @prop inComb {boolean} - Indica se l'oggetto appartiene a una combinazione
   */
  name: 'prodEditorFull',
  props: ['editing', 'listino', 'inComb'],
  components: { ProdEditor },
  data() {
    return {
      edited: null
    }
  },
  methods: {
    close() {
      this.$emit('close', null)
    },
    save(newObj) {
      this.$emit('close', newObj)
    },
    removePers() {
      this.$emit('remove-pers')
    },
    onCloneProductVariants(toCloneProduct) {
      this.$emit('cloneVariants', toCloneProduct)
    }
  },
  watch: {
    editing(newV) {
      const content = newV != null ? utils.clone(newV.content) : null
      const contentImg = newV !== null && newV.uploadImg !== null ? newV.uploadImg : null
      const contentPreviewImg = newV !== null && newV.base64 !== null ? newV.base64 : null
      const editViewType = newV !== null && newV.viewType !== null ? newV.viewType : null

      this.edited = {
        rowContent: content,
        rowImage: contentImg,
        rowPreviewImage: contentPreviewImg,
        rowViewType: editViewType
      }

      this.$refs.pageDialog.$parent.$parent.$el.classList.add('fullscreenDialog')
    }
  },
  computed: {
    dialog: {
      get() {
        return this.editing != null
      },
      set() {
        this.$emit('close')
      }
    },
    removePersEnabled() {
      return this.editing && this.editing.hasContentPers && this.editing.hasReference
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  padding: 64px 0 0 0
  height: 100vh
</style>



// WEBPACK FOOTER //
// src/components/common/ProdEditorFull.vue